export const STATIC_BRANDS = [
  {
    id: 11,
    slug: "smart",
    name: "SMART",
    title: "SMART",
    description:
      "برند SMART ارائه‌دهنده تجهیزات مدرن و باکیفیت برای حمام و سرویس بهداشتی با طراحی مینیمال و کاربرپسند.",
    logo: "/image/brand/smart.jpg",
  },
  {
    id: 12,
    slug: "eko",
    name: "EKO",
    title: "EKO",
    description:
      "برند EKO ارائه‌دهنده تجهیزات مدرن و باکیفیت برای حمام و سرویس بهداشتی با طراحی مینیمال و کاربرپسند.",
    logo: "/image/brand/eko.jpg",
  },
  {
    id: 13,
    slug: "defnebanyo",
    aliases: ["DefnoBanyo"],
    name: "DefneBanyo",
    title: "DefneBanyo",
    description:
      "برند DefneBanyo تخصص در طراحی و تولید لوازم بهداشتی مدرن با کیفیت بالا و دوام فوق‌العاده.",
    logo: "/image/brand/DefneBanyo.jpg",
  },
];

const STATIC_BRAND_LOOKUP = new Map();

for (const brand of STATIC_BRANDS) {
  STATIC_BRAND_LOOKUP.set(String(brand.id), brand);
  STATIC_BRAND_LOOKUP.set(brand.slug.toLowerCase(), brand);
  STATIC_BRAND_LOOKUP.set(brand.name.toLowerCase(), brand);

  for (const alias of brand.aliases || []) {
    STATIC_BRAND_LOOKUP.set(alias.toLowerCase(), brand);
  }
}

/**
 * @param {string | number | { id?: number | string, slug?: string, name?: string, title?: string }} input
 * @returns {(typeof STATIC_BRANDS)[number] | null}
 */
export function resolveStaticBrand(input) {
  if (!input) return null;

  if (typeof input === "object") {
    if (input.id != null) {
      const byId = STATIC_BRAND_LOOKUP.get(String(input.id));
      if (byId) return byId;
    }

    const slug = input.slug || input.name || input.title;
    if (slug) {
      return resolveStaticBrand(slug);
    }

    return null;
  }

  const key = decodeURIComponent(String(input)).toLowerCase();
  return STATIC_BRAND_LOOKUP.get(key) ?? null;
}

/**
 * @param {string | number | { id?: number | string, slug?: string, name?: string, title?: string }} input
 * @returns {string | number | null}
 */
export function getBrandApiId(input) {
  const brand = resolveStaticBrand(input);
  return brand?.id ?? null;
}

/**
 * @param {{ slug?: string, name?: string, title?: string, id?: number | string }} brand
 * @returns {string | null}
 */
export function getBrandSlug(brand) {
  const staticBrand = resolveStaticBrand(brand);
  if (staticBrand) return staticBrand.slug;

  if (!brand) return null;

  const slug = brand.slug || brand.name || brand.title;
  if (slug) return slug;

  if (brand.id) return String(brand.id);

  return null;
}

/**
 * @param {{ slug?: string, name?: string, title?: string, id?: number | string }} brand
 * @returns {string | null}
 */
export function getBrandHref(brand) {
  const slug = getBrandSlug(brand);
  if (!slug) return null;

  return `/brand/${encodeURIComponent(slug)}`;
}
